// Centralized contact information
export const CONTACT_INFO = {
  phone: '+12127098084',
  phoneDisplay: '(212) 709-8084',
  email: 'brandybeltasesq@gmail.com',
  address: {
    street: '30 Wall Street, 8th Floor',
    city: 'New York',
    state: 'New York',
    zip: '10005',
  },
  youtube: 'https://www.youtube.com/@BeltasLaw',
  mapUrl: 'https://maps.google.com/?q=30+Wall+Street+8th+Floor+New+York+NY+10005',
} as const;

export const PRACTICE_AREAS = [
  { name: 'Landlord-Tenant Law', href: '/landlord-tenant' },
  { name: 'Bankruptcy & Consumer Debt', href: '/consumer-law' },
] as const;
